import type {
  SurveyQuestion,
  SurveyCategory,
} from '../types/survey-config.types';

// Score threshold for determining positive vs negative responses
export const SURVEY_POSITIVE_SCORE_THRESHOLD = 50;

// Surveys-list-specific threshold: on the Surveys page, the Overall/category
// score column shows any score below this in red. Scoped to that page (the
// shared SURVEY_POSITIVE_SCORE_THRESHOLD used elsewhere stays at 50).
export const SURVEY_LIST_LOW_SCORE_THRESHOLD = 70;

// Backend alert types for surveys
export const SURVEY_ALERT_TYPES = {
  LOW_SCORE: 'low_score',
  COMMENTS: 'comments',
  NONE: 'none',
} as const;

// Alert type labels for display on frontend
export const SURVEY_ALERT_TYPE_LABELS: Record<string, string> = {
  [SURVEY_ALERT_TYPES.LOW_SCORE]: 'Low Score',
  [SURVEY_ALERT_TYPES.COMMENTS]: 'Comments',
  [SURVEY_ALERT_TYPES.NONE]: 'None',
};

// eNPS question (always last)
export const ENPS_QUESTION: SurveyQuestion = {
  id: 999,
  text: 'On a scale of 0 to 10, how likely are you to recommend our company as a place to work?',
  options: [
    { id: 0, label: '0', score: 0 },
    { id: 1, label: '1', score: 10 },
    { id: 2, label: '2', score: 20 },
    { id: 3, label: '3', score: 30 },
    { id: 4, label: '4', score: 40 },
    { id: 5, label: '5', score: 50 },
    { id: 6, label: '6', score: 60 },
    { id: 7, label: '7', score: 65 },
    { id: 8, label: '8', score: 70 },
    { id: 9, label: '9', score: 85 },
    { id: 10, label: '10', score: 100 },
  ],
};

export const ENPS_CATEGORY: SurveyCategory = {
  id: 999,
  name: 'eNPS',
  questions: [ENPS_QUESTION],
};

// eNPS Score Categories: Detractors (0-6), Passives (7-8), Promoters (9-10)
export const ENPS_CATEGORIES = {
  DETRACTOR: 'detractor',
  PASSIVE: 'passive',
  PROMOTER: 'promoter',
} as const;

// eNPS Score Ranges for each category
export const ENPS_SCORE_RANGES = {
  DETRACTOR: { min: 0, max: 6 },
  PASSIVE: { min: 7, max: 8 },
  PROMOTER: { min: 9, max: 10 },
} as const;

// Fixed category used for all customer feedbacks
export const CUSTOMER_FEEDBACK_CATEGORY = 'Customer Feedback';

// Survey filter constants
export const SURVEY_FILTER_VALUES = {
  DATE_RANGE: {
    ALL: 'all',
    LAST_7_DAYS: 'last_7_days',
    LAST_30_DAYS: 'last_30_days',
  },
  SURVEY_TYPE: {
    ALL: 'all',
    ROUTE_SURVEY: 'route_survey',
    INCIDENT_REPORT: 'incident_report',
    CUSTOMER_FEEDBACK: 'customer_feedback',
  },
  SCORE_CATEGORY: {
    OVERALL: 'overall',
  },
  ACCOUNT: {
    ALL: 'all',
  },
  ORGANIZATION_LEVEL: {
    ALL: 'all',
  },
} as const;
